import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UserRolesEnum } from 'src/app/common/enums/user-roles-enum';
import { DialogsManagerService } from 'src/app/services/dialogs-manager.service';
import { UserManageService } from 'src/app/services/user-manage.service';

@Component({
    selector: 'app-review-edit-user-dialog',
    templateUrl: './review-edit-user-dialog.component.html',
    styleUrls: ['./review-edit-user-dialog.component.css'],
    standalone: false
})
export class ReviewEditUserDialogComponent implements OnInit {

  currentUser=this.userManageService.currentUser
  editedUser=this.userManageService.editedUser
  currentClinic=this.userManageService.currentClinic
  currentOffice=this.userManageService.currentOffice
  currentClinicList=this.userManageService.newUserClinicList

  UserRolesEnum=UserRolesEnum
  
  constructor( private dialogRef: MatDialogRef<any>,
    private dialogsManagerService: DialogsManagerService,private userManageService:UserManageService, private dialog: MatDialog) { }

  ngOnInit(): void {
    console.log(this.currentUser)
    console.log(this.editedUser)
  }

  goBack()
  {
    this.dialogsManagerService.showEditUserDialogComponent()
    this.dialogRef.close(`Excellent`);
  }

  onSubmit()
  {

    this.userManageService.editUser()

    this.userManageService.clearUser()
    this.dialogRef.close(`Excellent`);
    this.dialog.closeAll()
    
  }
  
}
